import { CallResult } from '../../../Api/callExternalApi';

type CallError = NonNullable<CallResult<unknown>['error']>;

export const QUOTE_REVIEW_MOVED_ON =
  'This order request has moved on since the page loaded, so its quotes are no longer open for review.';
export const QUOTE_REVIEW_UNAVAILABLE = 'Quote review and approval is not available to you on this order request.';

// 404: the order has left review since the list was read. 403: review is not open to the user.
export const quoteReviewRefusal = (error: CallError): { message: string; movedOn: boolean } | undefined => {
  const status = error.errorResponse?.response?.status;
  if (status === 404) return { message: QUOTE_REVIEW_MOVED_ON, movedOn: true };
  if (status === 403) return { message: QUOTE_REVIEW_UNAVAILABLE, movedOn: false };
  return undefined;
};
